import { Label } from '@primer/react';
import { PropTableValues } from "../../../../src/components";
import { Link } from 'gatsby';
import ComponentLayout from "../../../../src/layouts/component-layout";
import { TextVariants } from '@primer/react-brand';
import * as React from 'react';
export default {
  Label,
  PropTableValues,
  Link,
  ComponentLayout,
  TextVariants,
  React
};